import { RecordedCallKey } from './EntityKeys';

export enum TranscriptionState {
    Started = 'started',
    Completed = 'completed',
    Failed = 'failed',
}

export interface RecordedCalls {
    transcriptionProgress: Record<RecordedCallKey, TranscriptionState>;
}
